import React, { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from './sections/Sidebar';
import { sections } from './sections';

const DRAWER = 240;

export default function AppDocs() {
  const [selected, setSelected] = useState(0);
  const Section = sections[selected].Component;

  return (
    /* ①  This Box is now the flex-row and flexes vertically */
    <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
      <Sidebar
        selectedIndex={selected}
        onSelect={setSelected}
        drawerWidth={DRAWER}
      />

      {/* ②  Main area stretches in both axes, scrolls if too tall */}
      <Box
        component="main"
        sx={theme => ({
          flex: 1,                   // ← fills row height; no shrink on short pages
          p: 3,
          pl: `${DRAWER}px`,         // room for the drawer
          transition: theme.transitions.create('padding-left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          overflow: 'auto',          // scroll only when content > viewport
        })}
      >
        <Section />
      </Box>
    </Box>
  );
}
